import { Vue, Component, Watch } from "vue-property-decorator";
import axios from "axios";
// Components
import {
  LeftCard,
  RightCard,
  Chart1,
  Chart2,
  Chart3,
  Chart4,
  Chart5,
  Snackbar,
  IdeaBox,
} from "@/components/index";
// Entities
import { Profile, Company, Warehouse, DataDashboard } from "@/entities/index";

@Component({
  components: {
    LeftCard,
    RightCard,
    Chart1,
    Chart2,
    Chart3,
    Chart4,
    Chart5,
    Snackbar,
    IdeaBox,
  },
})
export default class Dashboard extends Vue {
  @Watch("warehouseCode")
  onWarehouseChange(value: string, old: string): void {
    if (value !== old) {
      this.loadData();
    }
  }

  client = this.company.codeLogistic || this.profile.company.codeLogistic;
  idCompany = this.company.id;
  warehouseCode = "";
  integrateStepZero = this.company.integrateStepZero;

  warehouses: Warehouse[] = [];
  dataDashboard: DataDashboard[] = [];

  overlay = false;

  get company(): Company {
    return this.$store.getters.company;
  }

  get profile(): Profile {
    return this.$store.getters.profile;
  }

  async loadData(): Promise<void> {
    this.overlay = true;
    const userId = this.profile.id;
    await axios.post("/api/stats/action", { userId, action: "Dashboard" });
    // Left Card
    const leftCard = this.$refs.leftCard as LeftCard;
    leftCard.getDailyOrders();
    // Right Card
    const rightCard = this.$refs.rightCard as RightCard;
    rightCard.getOrderedParts();
    // Chart 1
    const chart1 = this.$refs.chart1 as Chart1;
    chart1.loadPiecesInStock();
    // Chart 2
    const chart2 = this.$refs.chart2 as Chart2;
    chart2.loadPiecesAndReferences();
    // Chart 3
    const chart3 = this.$refs.chart3 as Chart3;
    chart3.loadRealStockVSPrev();
    // Chart 4
    const chart4 = this.$refs.chart4 as Chart4;
    chart4.loadOrdersPerDays();
    // Chart 5
    const chart5 = this.$refs.chart5 as Chart5;
    chart5.loadPiecesCde();
    this.overlay = false;
  }

  async mounted(): Promise<void> {
    this.warehouses = (
      await axios.get(`/api/warehouses/company/${this.idCompany}`)
    ).data as Warehouse[];
    this.warehouseCode = this.warehouses[0].code;
  }

  // OTHER METHODS

  // Snackbar Refresh Data
  showSnackbar(): void {
    const snackbar = this.$refs.snackbar as Snackbar;
    snackbar.show();
  }

  showSnackbarSurvey(): void {
    const snackbarSurvey = this.$refs.snackbarSurvey as Snackbar;
    snackbarSurvey.show();
  }
}
